<template>
  <div class="palette">
    <div
      v-for="(color, index) in startGameConfig.colors"
      :key="color.val"
      :id="'color_' + index"
      @click="$emit('change-color', color.val)"
      :style="color.cssStyle"
      class="color"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'palette',
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
};
</script>

<style lang="sass" scoped>
.palette
  position: absolute
  width: 100%
  height: 100%
  pointer-events: none
  .color
    pointer-events: auto
</style>
